{
    "addToCart": "Ajouter au panier",
    "yes": "Oui",
    "no": "Non",
    "login": "Se connecter",
    "cancel": "Annuler",
    "close": "Fermer",
    "couponApplied": "Réduction appliquée\u202f?!",
    "unappliedCoupon": {
        "title": "Réduction non appliquée",
        "description": "Scannez le produit correspondant pour bénéficier de la réduction."
    },
    "done": "Terminer",
    "welcome": "Bienvenue",
    "welcomeScan": "Payez facilement et confortablement avec la caisse en libre service",
    "total": "Total",
    "toPayment": "Payer",
    "back": "Retour",
    "quantityNeeded": "Quantité nécessaire",
    "confirmCart": "Avez-vous scanné tous les articles\u202f?",
    "interactWithTerminal": "Veuillez interagir avec le terminal de paiement pour finaliser vos achats",
    "endTitle": "Achat réussi\u202f!",
    "endSubtitle": "Vous êtes prêt à partir. Nous vous remercions d’avoir fait vos achats chez nous\u202f!",
    "feedbackQuestion": "Comment s’est déroulée votre expérience\u202f?",
    "endThanksForFeedback": "Merci pour votre feedback\u202f!",
    "endSeeYouLater": "Au plaisir de vous revoir bientôt.",
    "getReceipt": "Reçu",
    "scanQRCode": "Veuillez scanner ce code QR pour télécharger votre reçu numérique.",
    "printReceipt": "Imprimer le reçu",
    "receiptPrinted": "✔ Reçu imprimé",
    "finalizeSession": "Finaliser la session",
    "productNotFound": "Oups\u202f! Nous ne trouvons pas cet article",
    "okDismiss": "OK",
    "somethingWentWrong": "Quelque chose n’a pas fonctionné",
    "pleaseTryAgain": "Veuillez réessayer",
    "pleaseWait": "Un moment...",
    "tryAgain": "Réessayer",
    "reload": "Recharger",
    "stillThere": "Êtes-vous encore là\u202f?",
    "continue": "Continuer",
    "startOver": "Recommencer",
    "scan": "Scannez un article pour l’ajouter à votre panier",
    "wantToStartOver": "Êtes-vous sûr de vouloir recommencer\u202f?",
    "wantToStartOverDescription": "Vous perdrez les articles scannés du panier et les réductions appliquées.",
    "changeLanguage": "Changer de langue",
    "ageVerification": "Scanner une pièce d’identité pour vérifier l’âge",
    "scanId": "Pour acheter ce produit, vous devez <strong>scanner votre pièce d’identité</strong> pour vérifier votre âge.",
    "holdIdSteady": "<strong>Remarque\u00a0:</strong> Veuillez tenir votre pièce d’identité bien droite en direction du scanner",
    "sorryCantSell": "Désolé, nous ne pouvons pas vous vendre ce produit",
    "sorryCantSellDescription": "Nous ne pouvons vendre ce produit qu’à des personnes de 18 ans ou plus.",
    "invalidId": "Nous n’avons pas pu scanner cet identifiant. Veuillez réessayer.",
    "verificationSuccessful": "Vérification réussie\u202f!",
    "startShopping": "Commencer les achats",
    "startShoppingKitchen": "Commander à manger",
    "wantToDeleteLineItem": "Êtes-vous sûr de vouloir supprimer l’article\u202f?",
    "wantToDeleteLineItemDescription": "Le produit sera supprimé de votre panier.",
    "promotionsDontWork": "<strong>Remarque\u00a0:</strong> les produits en promotion ne fonctionnent pas encore avec la caisse en libre service.",
    "addToBasket": "Ajouter",
    "promo": "Action",
    "product": "Produit",
    "productAdded": "Produit ajouté\u202f!",
    "product_other": "Produits",
    "operatorModeDialog": {
        "title": "Besoin d’aide\u202f?",
        "description": "Veuillez scanner votre badge d’employé pour plus d’actions."
    },
    "orderList": {
        "collapseDetails": "Réduire",
        "expandDetails": "Développer",
        "details": "Détails",
        "title": "Commandes"
    },
    "checkoutError": {
        "default": "Oops, votre paiement a échoué. Veuillez réessayer.",
        "AbortedByUser": "Le paiement a été annulé, veuillez réessayer.",
        "PaymentDeviceNotFound": "Aucun terminal de paiement n'a pu être trouvé pour ce SCO.",
        "CouponNotFound": {
            "title": "Coupon introuvable",
            "description": "Ce coupon ne peut pas être appliqué car il est introuvable."
        },
        "CouponNotApplicable": {
            "title": "Coupon inapplicable",
            "description": "Ce coupon ne correspond à aucun article de votre panier. Veuillez d’abord scanner le produit."
        },
        "CouponExpired": {
            "title": "Coupon expiré",
            "description": "Ce coupon ne peut pas être appliqué car il a expiré."
        },
        "CouponAlreadyRedeemed": {
            "title": "Coupon déjà utilisé",
            "description": "Ce coupon ne peut pas être appliqué car il a déjà été utilisé."
        },
        "CouponRedemptionFailed": {
            "title": "Échec de l'application du coupon",
            "description": "L'application de ce coupon a échoué. Veuillez réessayer."
        }
    },
    "operatorMode": "Mode opérateur",
    "operator": {
        "configuration": {
            "title": "Configuration",
            "individualConfig": {
                "title": "Configuration au niveau du SCO"
            },
            "storeConfig": {
                "title": "Configuration au niveau du magasin"
            },
            "status": {
                "label": "SCO activée",
                "confirmDisable": "Êtes‑vous sûr de vouloir désactiver le SCO\u202f?",
                "confirmEnable": "Êtes‑vous sûr de vouloir activer le SCO\u202f?"
            },
            "cartCheck": {
                "label": "Vérification du panier activée",
                "confirmDisable": "Êtes-vous sûr de vouloir désactiver la vérification du panier\u202f?",
                "confirmEnable": "Êtes-vous sûr de vouloir activer la vérification du panier\u202f?"
            }
        },
        "hardware": {
            "title": "Matériel",
            "lamp": "Lampe",
            "printer": "Imprimante",
            "scanner": "Scanner",
            "red": "Rouge",
            "green": "Vert",
            "print": "Imprimer reçu fictif",
            "clear": "Effacer",
            "blink": "Clignoter",
            "paymentTerminal": "Terminal de paiement",
            "login": "Se connecter",
            "paymentDeviceConfig": {
                "currentIp": "Adresse IP actuelle",
                "ipLabel": "Nouvelle adresse IP",
                "invalidIp": "Adresse IP invalide",
                "setIp": "Définir l'IP",
                "probe": "Sonder",
                "probeSucceeded": "Sondage réussi",
                "probeFailed": "Échec du sondage",
                "loginSucceeded": "Connexion réussie",
                "loginFailed": "Échec de la connexion : {{reason}}",
                "status": "Statut",
                "statuses": {
                    "ready": "Prêt",
                    "requiresLogin": "Connexion requise",
                    "unreachable": "Injoignable"
                },
                "ipUpdated": "Adresse IP mise à jour",
                "ipUpdateFailed": "Échec de la mise à jour de l'adresse IP : {{reason}}",
                "alterIp": "Modifier l'IP",
                "dialogTitle": "IP du terminal de paiement",
                "close": "Fermer"
            }
        },
        "systemInformation": {
            "title": "Informations système",
            "deviceId": "Identifiant de la machine",
            "cashRegisterId": "Identifiant de la caisse SAP",
            "paymentDeviceId": "Identifiant de l'appareil de paiement",
            "paymentDeviceIp": "Adresse IP de l'appareil de paiement",
            "runningVersion": "Version en cours d'exécution",
            "storeId": "Identifiant du magasin",
            "productPresetIds": "Identifiants des produits préréglés",
            "kitchenMenuId": "Identifiant du menu de The Kitchen",
            "tenant": "Entité"
        }
    },
    "order": "Commande",
    "order_other": "Commandes",
    "insight": "Insight",
    "insight_other": "Insights",
    "insightGrouping": {
        "groupBy": "Grouper par",
        "scoId": "Self-checkout",
        "category": "Catégorie"
    },
    "productCategory": {
        "label": "Catégorie",
        "ABF": "Déchets",
        "BTRM": "Matériel d’exploitation",
        "BUCH": "Livres",
        "CBAU": "Unité compatible",
        "CH00": "CH Gestion de contrats",
        "CONT": "Conteneur Kanban",
        "COUP": "Coupon",
        "DIEN": "Service non commandé",
        "DLU1": "Service commandé",
        "EPA": "Paquet d’équipement",
        "ERSA": "Pièces de rechange",
        "FERT": "Produits finis",
        "FGTR": "Boissons",
        "FHMI": "Matériel de fabrication ",
        "FOOD": "Alimentation (hors produits frais)",
        "FRIP": "Produits frais",
        "HALB": "Produits semi-finis",
        "HAWA": "Marchandise",
        "HERS": "Pièces du fabricant",
        "HIBE": "Matériaux auxiliaires/de fonctionnement",
        "IBAU": "Maintenance - élément de montage",
        "INTR": "Intra matériel",
        "KMAT": "Matériel configurable",
        "LEER": "Bouteilles consignées",
        "LEIH": "Emballage consigné",
        "LGUT": "Bouteilles consignées (trop pleines)",
        "MODE": "Mode (saisonnier)",
        "MPO": "Objet de planification des matériaux",
        "NLAG": "Matériau non stocké",
        "NOF1": "Non-alimentaire",
        "PIPE": "Matériel de pipeline",
        "PLAN": "Marchandise (prévue)",
        "PRES": "Presse",
        "PROC": "Matériau de transformation",
        "PROD": "Groupe de produits",
        "ROH": "Matière première",
        "TBAK": "Tabac",
        "UNBW": "Matériel non évalué",
        "VBFO": "Matière consommable. ALIMENTATION",
        "VERP": "Emballage",
        "VKHM": "Accessoires de vente",
        "VOLL": "Produit pleint",
        "WERB": "Matériel publicitaire",
        "WERT": "Matériel de valeur",
        "WETT": "Produit concurrent",
        "ZAUF": "Article de dépense",
        "ZAUS": "Numéro de presse",
        "ZFRG": "Frais de franchisage",
        "ZGIF": "Cartes cadeaux Ravita",
        "ZILV": "AGS\u202f: Contrat de service international",
        "ZITP": "AGS\u202f: Projets informatiques",
        "ZLEI": "Matériel de prêt Kiosk AG",
        "ZLOG": "Services de logistique",
        "ZMFE": "AGS\u202f: Frais de gestion",
        "ZOBJ": "Objet de presse",
        "ZRAV": "Codes PIN Ravita",
        "ZSER": "AGS\u202f: Articles de service"
    },
    "totalRevenue": "Recettes totales",
    "needReceipt": "<strong>Besoin d’un reçu\u202f?</strong> Vous pouvez le trouver dans l’appli sous Réglages > Historique d’achats",
    "orderNumber": "Commande",
    "takeReceipt": "<strong>Important</strong>\u202f: Veuillez prendre le ticket de la commande et le donner au personnel lors du retrait de vos articles.",
    "kitchen": "Kitchen",
    "theKitchen": "The Kitchen",
    "kitchenMenu": {
        "backToCart": "Retour au panier",
        "productUnavailable": "Indisponible",
        "allergens": "Allergènes",
        "nutritionalInformation": "Ingrédients et origine",
        "productInformation": "Informations sur le produit",
        "upsellingTitle": "Quelque chose d’autre avec ça\u202f?"
    },
    "availableAtAvec": "Disponible dans cet Avec",
    "kitchenDescription": "Appuyez sur le bouton The Kitchen pour ouvrir le menu",
    "unknown": "Inconnu",
    "dateRangePicker": {
        "from": "Du",
        "to": "Au"
    },
    "outOfOrder": {
        "title": "Oups\u202f! Un problème est survenu ",
        "subtitle": "La caisse en libre service est temporairement hors service, mais nous travaillons dur pour la réparer."
    },
    "cartCheckTriggered": "Votre panier a été sélectionné au hasard pour un contrôle manuel. Veuillez attendre que le personnel vienne vers vous.",
    "cartError": {
        "Unknown": {
            "title": "Oups\u202f! Un problème est survenu. Veuillez réessayer."
        },
        "CouponAlreadyRedeemed": {
            "title": "Coupon déjà utilisé",
            "body": "Le coupon a déjà été utilisé. Veuillez vérifier le coupon et réessayer."
        },
        "ServiceNotSellable": {
            "title": "Veuillez utiliser une caisse avec personnel",
            "body": "Cet article ne peut être acheté qu’à une caisse avec personnel."
        },
        "CouponNotApplicable": {
            "title": "Coupon inapplicable",
            "body": "Ce coupon ne correspond à aucun article de votre panier. Veuillez d’abord scanner le produit."
        }
    }
}
